import { useState, useEffect, useContext  } from 'react';
import axios from 'axios';

import { Box, Card, CardActionArea, CardContent, CircularProgress, Divider,
     Paper, Stack, ThemeProvider, Typography} from  '@mui/material';

import Grid2 from '@mui/material/Unstable_Grid2'; // Grid version 2


import { createTheme } from '@mui/material/styles';

import {ccColorDarkTeal, ccColorSecondaryAzure, ccColorSecondaryBronze, ccColorSecondaryGreen, ccColorSecondaryPink, ccColorSecondaryPurple, lionProductColors} from '../components/helpersStyles';

import {SettingsContext} from '../components/userSettingsContext'

import {SnippetTypeGrid, CcSnippetTypeGrid} from '../commonComponents/snippetTypesGrid';

import { CcTitle } from '../commonComponents/styledTexts';

import CountUp from 'react-countup';
import GaugeComponent from 'react-gauge-component';
import { InfoToolTip } from '../commonComponents/generalComponents';
import { Icon as Iconify } from '@iconify/react';
import { useNavigate } from 'react-router-dom';
import introJs from 'intro.js';
import 'intro.js/introjs.css'
import '../ccIntroJs/ccIntroJsStyles.css'
import { CcIntroJsStyledText } from '../ccIntroJs/ccIntroJsStyledText';
import { showIntroJsTourForCurrentPage } from '../ccIntroJs/ccIntroJsDisplayLogic';


const theme = createTheme({
  palette: {
    // primary: {
      // light: will be calculated from palette.primary.main,
      // main: '#ff4400',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    // },
    // secondary: {
      // light: '#0066ff',
      // main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      // contrastText: '#ffcc00',
    // },
    // Provide every color token (light, main, dark, and contrastText) when using
    // custom colors for props in Material UI's components.
    // Then you will be able to use it like this: `<Button color="custom">`
    // (For TypeScript, you need to add module augmentation for the `custom` value)
    customCircularLoader: {
      // light: '#ffa726',
      main: '#000',
      // dark: '#ef6c00',
      // contrastText: 'rgba(0, 0, 0, 0.87)',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    // contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    // tonalOffset: 0.2,
  },
});


const LionAccountStat = (props) => {

    const [showProgress, setShowProgress] = useState(true);
    const [theNumber, setTheNumber] = useState(0);

    useEffect(() => {
        getStats(props.endpoint)
    }, [])

    const getStats = async (endpoint) => {
        try {
            // const url = `api/Stats/${endpoint}`;
            const url = `${process.env.REACT_APP_LION_API_URL}/Stats/${endpoint}`

            const response = await axios.get(url);
            const data = response.data;


            setTheNumber(data);
            setShowProgress(false)
                    
        } catch (error) {
            console.log(error);
        }  

        }

      
    return <ThemeProvider theme={theme}>
    <Stack>
        <div className=' font-roboto text-lg text-gray-600'>{props.title}</div>

        <Paper elevation={4} sx={{...props.sx, maxWidth: 500, minWidth: 250, minHeight: 50 }}>
            <Box display="flex" justifyContent="center" alignItems='center' sx={{minHeight: 50}} >
                {showProgress &&  <CircularProgress size={22} color='customCircularLoader' />}
                {!showProgress && !props.percentage && <Typography sx={{fontSize: 24, fontWeight: 'bold'}} >{new Intl.NumberFormat().format(theNumber)}</Typography>}
                {!showProgress && props.percentage && <Typography sx={{fontSize: 24, fontWeight: 'bold'}} >{theNumber} %</Typography>}
            </Box>
        
    </Paper>
        </Stack>
        </ThemeProvider>
}

const CcAccountStatsTile = (props) => {
    const [showProgress, setShowProgress] = useState(true);
    const [theNumber, setTheNumber] = useState(0);

    useEffect(() => {
        getStats(props.endpoint)
    }, [])

    const getStats = async (endpoint) => {
        try {
            // const url = `api/Stats/${endpoint}`;
            const url = `${process.env.REACT_APP_LION_API_URL}/Stats/${endpoint}`

            const response = await axios.get(url);
            const data = response.data;

            setTheNumber(data);
            setShowProgress(false)
                    
        } catch (error) {
            console.log(error);
        }  

        }

    return <div style={{backgroundColor: props.color}} className='h-36 px-6 py-5 w-full font-poppins' >
        <div className=' text-white'>{props.title}</div>
        {showProgress && <div className='flex flex-row justify-center mt-4 text-white'> <CircularProgress size={32} color='inherit'  /></div>}

        {!showProgress && <>
            
        <div className=' text-white font-bold text-3xl'>{/*new Intl.NumberFormat().format(theNumber)*/}<CountUp end={theNumber} /></div>

        {/*
            <div className='flex flex-row justify-end w-full'>
                <div style={{color: props.color}} className=' bg-white/70 rounded-sm font-semibold py-1 px-2 text-xs'>+9%</div>
            </div>
            <div className='flex flex-row justify-end w-full'>
                <div className=' text-white py-1  text-[10px]'>compared to last week</div>
            </div>
         */}
        </>
        }
    </div>
}
const CcAccountStatsGaugeTile = (props) => {
    const deltaPercentage = 0.1; //the plus/minus percentage band for the "OK on track" values
    const [showProgress, setShowProgress] = useState(true);
    const [expectedUsage, setExpectedUsage] = useState(0);
    const [actualUsage, setActualUsage] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        getStats(props.endpoint)
    }, [])

    const classifyUsage = () => {
        if (expectedUsage > 0 && actualUsage >= expectedUsage - deltaPercentage*expectedUsage
            && actualUsage <= expectedUsage + deltaPercentage*expectedUsage)
            return "ok"
        else if (expectedUsage > 0 && actualUsage < expectedUsage - deltaPercentage*expectedUsage)
            return "low"
        else
            return "high"
    }
    const getUsageMessage = () => {
        switch (classifyUsage()) {
            case "ok":
                return "Your impression usage is pacing as expected and right on track."
            case "low":
                return "You’re consuming fewer impressions than available, leaving unused images this period."
            case "high":
                return "You’re consuming impressions faster than planned and may reach your limit early."
            default:
                return ""
        }
    }

    const OneWordLabel = () => {
        if (classifyUsage() === 'ok')
        return <div className='bg-white px-2 py-0.5 rounded text-green-600 text-sm font-semibold flex flex-row items-center gap-x-1'><div>OK</div><Iconify icon="material-symbols:info-outline" width="18px" /></div>
        if (classifyUsage() === 'low')
        return <div className='bg-white px-1 py-0.5 rounded text-yellow-600 text-sm font-semibold flex flex-row items-center gap-x-1'><div>LOW</div><Iconify icon="material-symbols:info-outline" width="18px" /></div>
        if (classifyUsage() === 'high')
        return <div className='bg-white px-2 py-0.5 rounded text-red-600 text-sm font-semibold flex flex-row items-center gap-x-1'><div>HIGH</div><Iconify icon="material-symbols:info-outline" width="18px" /></div>
    }

    const getStats = async (endpoint) => {
        try {
            // const url = `api/Stats/${endpoint}`;
            const url = `${process.env.REACT_APP_LION_API_URL}/Stats/${endpoint}`

            const response = await axios.get(url);
            const data = response.data;
            
            if (data === 0) {
                setExpectedUsage(0)
                setActualUsage(0)
                setShowProgress(false)
                return
            }
            const start = new Date(data.periodInfo.periodStart)
            const end = new Date(data.periodInfo.periodEnd)
            const periodImpressions = data.periodInfo.impressions
            const periodDays = Math.floor((end - start) / (1000 * 60 * 60 * 24));
            const daysPassed = Math.floor((new Date() - start) / (1000 * 60 * 60 * 24));
            const expectedDailyImpressions = Math.floor(periodImpressions / periodDays)
            const actualDailyImpressions = Math.floor(data.totalImpressions / daysPassed)
            
            setActualUsage(actualDailyImpressions);
            setExpectedUsage(expectedDailyImpressions)
            setShowProgress(false)
                    
        } catch (error) {
            console.log(error);
        }  

        }

    return <div style={{backgroundColor: props.color}} className={`h-36 px-6 py-5 w-full font-poppins ${expectedUsage > 0 ? 'cursor-pointer' : ''}`}
                onClick={() => {if (expectedUsage > 0) navigate(`/admin/pacing`)}} >
        <div className='flex flex-row items-center'>
            <div className=' text-white'>{props.title}</div>
            {!showProgress && expectedUsage > 0 && <>
                <div className='flex grow'></div>
                <InfoToolTip
                    custom={<OneWordLabel />}
                    placement='right'
                    headLine={`Pacing ${classifyUsage().toUpperCase()}`}
                    message={<div className='flex flex-col gap-y-2'><div><span className='font-semibold bg-slate-200 rounded p-1'>Actual usage:</span> {actualUsage} avg impressions/day</div>
                            <div><span className='font-semibold bg-slate-200 rounded p-1'>Expected usage:</span> {expectedUsage} avg impressions/day</div>
                            <div className='mt-1'>{getUsageMessage()}</div>
                            </div>}
                />
            
            </>}

        </div>
        {showProgress && <div className='flex flex-row justify-center mt-4 text-white'> <CircularProgress size={32} color='inherit'  /></div>}


        {!showProgress && <>
            {expectedUsage === 0 ?
                <div className=' text-white font-bold text-3xl'>0</div>
            :
            <div className=''>
                <GaugeComponent
                    style={{height: '100px'}}
                    type="semicircle"
                    marginInPercent={{ top: 0.01, bottom: 0.1, left: 0.0, right: 0.0 }}
                    arc={{
                        //colorArray: ['#00FF15', '#FF2121',],
                        padding: 0.02,
                        subArcs:
                        [
                            { limit: expectedUsage - deltaPercentage*expectedUsage, color: 'white' },
                            { limit: expectedUsage + deltaPercentage*expectedUsage, color: ccColorSecondaryGreen },
                            { limit: 2*expectedUsage, color: 'white' },
                            {}
                        ]
                    }}
                    pointer={{type: "needle", animationDelay: 0, color: '#ccc' }}
                    value={actualUsage}
                    minValue={0}
                    maxValue={2*expectedUsage}
                    labels={{valueLabel: {hide: true, style: {textShadow: ''}}, tickLabels: {type: 'inner', defaultTickLineConfig: {hide: true, color: '#fff'}, defaultTickValueConfig: {hide: true, style: {fill: '#fff'}}}}}
                />
            </div>
        }
            

        </>
        }
    </div>
}

const CcAccountStatsBar = (props) => {

    return <div className='flex flex-row gap-x-0'>
        <CcAccountStatsTile color={ccColorSecondaryPink} title='Today'
                                            endpoint='opens/today'
                                            />
        <CcAccountStatsTile color={ccColorSecondaryGreen} title='This month'
                                            endpoint='opens/thisMonth'
                                            />
        <CcAccountStatsTile color={ccColorSecondaryPurple} title='This term'
                                            endpoint='opens/thisTerm'
                                            />
        <CcAccountStatsGaugeTile color={ccColorSecondaryAzure} title='Pacing'
                                            endpoint='opens/pacing'
                                            />
        <CcAccountStatsTile color={ccColorSecondaryBronze} title='Clicks this month'
                                            endpoint='clicks/thisMonth'
                                            />

    </div>
}


export default function HomeComponent() {

    const [enabledProductIds, setEnabledProductIds] = useState([]);
    const {settings, setSettings} = useContext(SettingsContext);

    useEffect(() => {
        // setEnabledProductIds(settings.enabledProductIds);
    }, [settings])

    useEffect(() => {
        showIntroJsTourForCurrentPage(introJs)
    }, [])

    return <Stack spacing={2} sx={{backgroundSize: 'cover', backgroundImage: `url("/assets//backgroundDashboardCircles.png")`}}>
            <CcTitle><div data-intro={CcIntroJsStyledText({title: 'Your usage at a glance', mainText: 'Instantly see how your image usage is tracking and compare it to your contracted allowance so you always know exactly how much you’re using. The main usage bar shows today, this month, your current term, pacing against your purchased images, and clicks this month, helping you stay informed, avoid overages, and keep your campaigns running smoothly.'})}>Real-time usage</div></CcTitle>
            {/*
            <Stack direction='row' spacing={3} sx={{width: '100%'}}>
                <LionAccountStat title='Today'
                                    sx={{backgroundColor: indigo[200]}}
                                    endpoint='opens/today'
                />
                <LionAccountStat title='This month'
                                    sx={{backgroundColor: indigo[200]}}
                                    endpoint='opens/thisMonth'
                />
                <LionAccountStat title='This term'
                                    sx={{backgroundColor: indigo[200]}}
                                    endpoint='opens/thisTerm'
                />
                <LionAccountStat title='Pacing'
                                    sx={{backgroundColor: indigo[200]}}
                                    endpoint='opens/pacing'
                                    percentage
                />

            </Stack>
            <Stack direction='row' spacing={3} sx={{width: '100%'}}>
                <LionAccountStat title='Clicks this month'
                                    sx={{backgroundColor: pink[200]}}
                                    endpoint='clicks/thisMonth'
                />
            </Stack>
            */}
            <CcAccountStatsBar />
{/*
            <Stack direction='row' spacing={3} sx={{width: '100%'}}>
            <LineChartOpens />
            <PieChartOpens />
            <PieChartDeviceType />
            </Stack>
            <Stack direction='row' spacing={3} sx={{width: '100%'}}>
            <PieChartMobileVsNonMobile />
            <PieChartBrowser />
            </Stack>
*/}
            <Divider variant="middle" />
            <CcTitle><div data-intro={CcIntroJsStyledText({title: 'Create your first element', mainText: 'Click a tile below to create your first element. Follow the steps in the Element Hub, then copy and paste the generated code into your email. Your first tag awaits!'})}>Click on an element to get started</div></CcTitle>
            {/*<SnippetTypeGrid />*/}
            <CcSnippetTypeGrid />
    </Stack>
}